import dynamic from "next/dynamic";

export const TeamMemberDetailCard = dynamic(() => import("./component"));
